import CalenderIcon from "shared/assets/icons/calender_v2.svg";
import CallIcon from "shared/assets/icons/call_v2.svg";
import ChimeIcon from "shared/assets/icons/chime.svg";
import HeartIcon from "shared/assets/icons/heart.svg";
import PeoPleIcon from "shared/assets/icons/people.svg";
import TalkIcon from "shared/assets/icons/talk.svg";
import TalkV2Icon from "shared/assets/icons/talk_v2.svg";
import { css } from "styled-components";

import { Stepper } from "./Stepper";

const ChatTalkIcon = () => (
  <TalkIcon
    tw="svg text-[#774AF5]"
    css={css({ transform: "scale(-1,1)" })}
    width={26.49}
    height={24.79}
    viewBox="0, 0, 9.5, 10"
  />
);

const chatSteps = [
  {
    icon: <PeoPleIcon />,
    title: "占い師・メニューを選択、お支払い",
    description:
      "気になる占い師さんを選んでスマホで簡単申し込み!待機中ならいますぐ鑑定◉",
  },
  {
    icon: <ChimeIcon />,
    title: "鑑定スタートでLINE通知",
    description:
      "占い師さんが鑑定を開始したらLINE・メールで通知♫チャットで占う内容の変更や相談が可能に",
  },
  {
    icon: <TalkV2Icon />,
    title: "チャットで鑑定結果が届く",
    description:
      "相談内容に沿ったボリューム満点の鑑定結果がチャットルームに届きます！",
  },
  {
    icon: <ChatTalkIcon />,
    title: "チャットで気軽に質問・相談",
    description:
      "鑑定結果への質問や相談、追加の鑑定のお願いなど自由にチャットでやりとりできます♡",
  },
];

const telSteps = [
  {
    icon: <PeoPleIcon />,
    title: "占い師・メニューを選択、お支払い",
    description:
      "気になる占い師さんを選んでスマホで簡単申し込み!待機中ならいますぐ鑑定◉",
  },
  {
    icon: <CalenderIcon />,
    title: "チャットで日程相談",
    description:
      "チャットルームで電話鑑定の日時を相談して決定。待機中の場合は申込後すぐに電話開始！",
  },
  {
    icon: <CallIcon />,
    title: "時間になったら着信があります",
    description:
      "相談して決めた日時になったらMIRORのシステムから着信が入り電話鑑定がスタート♫",
  },
  {
    icon: <HeartIcon />,
    title: "安心して使える電話システム",
    description:
      "お客様の電話番号が占い師さんに知られることはないので、安心してご利用可能です！",
  },
];

interface Props {
  isTel?: boolean;
  className?: string;
}

export const FortuneStepGuide = ({ isTel, className }: Props) => {
  return (
    <Stepper
      steps={isTel ? telSteps : chatSteps}
      className={className}
      vertical
    />
  );
};
